export default __webpack_public_path__ + "static/media/ability_img.c5768226.png";